<main class="container-fluid">
  <app-admin-sidebar></app-admin-sidebar>
  <div class="profile-container gap-3">
    <div class="w-100 mb-5" *ngIf="retrievedUser">
      <a class="text-decoration-none" routerLink="../">
        <i class="bi bi-arrow-left me-2"></i>Terug naar overzicht
      </a>
      <h1 class="subtitle mt-3">Gebruiker beheren</h1>
      <table class="profile-details">
        <tr>
          <td class="profile-text">Gebruikersnaam</td>
          <td>{{ retrievedUser.name }}</td>
        </tr>
        <tr>
          <td class="profile-text">E-mailadres</td>
          <td>{{ retrievedUser.email }}</td>
        </tr>
        <tr>
          <td class="profile-text">Status account</td>
          <td>{{ retrievedUser.active ? "Actief" : "Inactief" }}</td>
        </tr>
        <tr>
          <td class="profile-text">Admin</td>
          <td>{{ retrievedUser.admin ? "Ja" : "Nee" }}</td>
        </tr>
        <tr>
          <td class="profile-text">Aanmaakdatum account</td>
          <td>{{ retrievedUser.created }}</td>
        </tr>
      </table>
      <div class="action-buttons" *ngIf="retrievedUser.uid !== user.uid && !retrievedUser.superAdmin">
        <div class="row button-row">
          <button class="btn btn-primary profile-button mt-3" (click)="presentConfirmationModal('Activate')">
            {{ retrievedUser.active ? "Account deactiveren" : "Account activeren" }}
          </button>
        </div>
        <div class="row button-row" *ngIf="user.superAdmin">
          <button class="btn btn-primary profile-button mt-3" (click)="presentConfirmationModal('Admin')">
            {{ retrievedUser.admin ? "Adminrechten ontnemen" : "Adminrechten geven"}}
          </button>
        </div>
      </div>
    </div>
  </div>
</main>

